import React from 'react';
import AccountVerificationForm from '../forms/AccountVerificationForm/AccountVerificationForm';
import AHRIForm from '../forms/AHRILookupForm/AHRILookupForm';
import ContractorDetailsForm from '../forms/ContractorDetailsForm/ContractorDetailsForm';
import EligibilityQuestionsForm from '../forms/EligibilityQuestionsForm/EligibilityQuestionsForm';
import EligibilitySummary from '../EligibilitySummary/EligibilitySummary';
import ScheduleQuestionsForm from '../forms/ScheduleQuestionsForm/ScheduleQuestionsForm';
import HomeDetailsQuestionsForm from '../forms/HomeDetailsQuestionsForm/HomeDetailsQuestionsForm';
import UploadFilesForm from '../forms/UploadFilesForm/UploadFilesForm';
import ProductInformationForm from '../forms/ProductInformationForm/ProductInformationForm';
import PayeeForm from '../forms/PayeeForm/PayeeForm';
import RetailerForm from '../forms/RetailerForm/RetailerForm';
import Typography from '@material-ui/core/Typography';
import TermsAndConditionsForm from '../forms/TermsAndConditions/TermsAndConditionsForm';

export default function getForm(group, handleNext, handleBack) {
  var forms = {
    "ahri": AHRIForm,
    "contractor": ContractorDetailsForm,
    "eligibility": EligibilityQuestionsForm,
    "homeDetails": HomeDetailsQuestionsForm,
    "payee": PayeeForm,
    "product": ProductInformationForm,
    "retailer": RetailerForm,
    "review": EligibilitySummary,
    "schedule": ScheduleQuestionsForm,
    "terms": TermsAndConditionsForm,
    "upload": UploadFilesForm,
    "validate": AccountVerificationForm,
    "default": null
  };

  const FormComponent = forms[group.id];
  return FormComponent
    ? <React.Fragment>
      <FormComponent group={group} handleNext={handleNext} handleBack={handleBack} />
      {group.footerMessage &&
        <Typography
          variant="body2"
          align="center"
          style={{
            marginTop: 20
          }}
        >
          {group?.footerCheck?<strong>{group.footerMessage }{<a style={{"textDecoration":"none", "color":"#5093D4"}} href={group.groupUrl} rel="noopener noreferrer" target="_blank">{group.footerText}</a>}</strong>:<strong>{group.footerMessage }</strong>}        
        </Typography>}
    </React.Fragment>
    : forms["default"];
}
